import 'flickity/dist/flickity.pkgd.min';
import 'masonry-layout';
